module.exports = __webpack_public_path__ + "img/gradyelblue-mob.d87e814e.png";